
import Button from '../../../components/base/Button';

export default function PricingSection() {
  const plans = [
    {
      name: "Starter Course",
      price: "$300",
      period: "one-time",
      description: "Perfect for beginners who want to test our method",
      features: [
        "Complete beginner course (4 weeks)",
        "Grammar basics made simple",
        "Essential vocabulary (500+ words)",
        "Pronunciation guide",
        "Basic American slang",
        "Lifetime access to materials",
        "Email support"
      ],
      popular: false,
      buttonText: "Start Learning",
      badge: "Great Value"
    },
    {
      name: "Complete Program",
      price: "$900",
      period: "one-time",
      description: "Our full English mastery program - most popular choice",
      features: [
        "Complete 12-week program",
        "All 4 core modules included",
        "Advanced grammar simplified",
        "2000+ useful vocabulary words",
        "Perfect pronunciation training",
        "Complete American slang guide",
        "Interactive exercises & quizzes",
        "Progress tracking",
        "Lifetime access + updates",
        "Priority email support"
      ],
      popular: true,
      buttonText: "Get Complete Program",
      badge: "Best Value"
    },
    {
      name: "VIP Membership",
      price: "$40",
      period: "per month",
      description: "Ongoing support with new content every month",
      features: [
        "Everything in Complete Program",
        "New lessons added monthly",
        "Advanced conversation topics",
        "Business English modules",
        "Cultural insights & tips",
        "Live Q&A sessions (monthly)",
        "Private community access",
        "Direct instructor support",
        "Cancel anytime"
      ],
      popular: false,
      buttonText: "Join VIP",
      badge: "Ongoing Support"
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Choose Your English Learning Journey
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Start speaking English confidently with our proven method. Choose the option that fits your goals and budget. 
            All programs include our easy-to-follow system that gets results fast.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div 
              key={index} 
              className={`relative bg-white rounded-2xl shadow-lg overflow-hidden ${
                plan.popular ? 'ring-2 ring-blue-600 transform scale-105' : ''
              }`}
            >
              {plan.popular && (
                <div className="absolute top-0 left-0 right-0 bg-blue-600 text-white text-center py-2 text-sm font-medium">
                  Most Popular Choice
                </div>
              )}
              
              <div className={`p-8 ${plan.popular ? 'pt-12' : ''}`}>
                <div className="text-center mb-8">
                  <div className="inline-block bg-green-100 text-green-800 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                    {plan.badge}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <p className="text-gray-600 mb-4">{plan.description}</p>
                  <div className="mb-4">
                    <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                    <span className="text-gray-600 ml-2">{plan.period}</span>
                  </div>
                </div>

                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <i className="ri-check-line text-green-600 mt-1 mr-3 flex-shrink-0"></i>
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  variant={plan.popular ? 'primary' : 'outline'}
                  fullWidth
                  size="lg"
                  onClick={scrollToContact}
                >
                  {plan.buttonText}
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white rounded-xl shadow-lg p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              <i className="ri-shield-check-line text-green-600 mr-2"></i>
              30-Day Money-Back Guarantee
            </h3>
            <p className="text-gray-600 mb-6">
              Try our program risk-free! If you're not completely satisfied with your progress in 30 days, 
              we'll refund every penny. No questions asked.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={scrollToContact}>
                <i className="ri-message-3-line mr-2"></i>
                Have Questions? Contact Us
              </Button>
              <Button variant="outline">
                <i className="ri-download-line mr-2"></i>
                Download Free Sample
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="flex items-center justify-center">
              <i className="ri-download-cloud-line text-2xl text-blue-600 mr-3"></i>
              <span className="text-gray-700">Instant Access After Purchase</span>
            </div>
            <div className="flex items-center justify-center">
              <i className="ri-smartphone-line text-2xl text-green-600 mr-3"></i>
              <span className="text-gray-700">Works on All Devices</span>
            </div>
            <div className="flex items-center justify-center">
              <i className="ri-time-line text-2xl text-purple-600 mr-3"></i>
              <span className="text-gray-700">Learn at Your Own Pace</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
